import type {ScaleProperty} from "../../_types/ScaleProperty";
import {SceneObjectWithColorData} from "../../_types/SceneObjectWithColorData";
import type {Size} from "../../_types/Size";
import type {WebGLRenderObject} from "../../_types/WebGLRenderObject";
import {getRandomNumberBetween} from "../../helpers/getRandomNumberBetween";
import {ObjectPipelinePass} from "../ObjectPipeline";

export class ScaleObjectPass implements ObjectPipelinePass {

    constructor(
        private sceneSize: Size,
        private options: ScaleProperty) {}

    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    public apply(
        index: number,
        renderObject: WebGLRenderObject,
        sceneObjects: Array<SceneObjectWithColorData>
    ): void {

        const diagonal = Math.sqrt(
            Math.pow(this.sceneSize.width, 2) + Math.pow(this.sceneSize.height, 2));

        const renderObjectAspectRatio = renderObject.width / renderObject.height;

        renderObject.width = renderObjectAspectRatio > 1
            ? diagonal * this.options.width
            : diagonal * this.options.width * renderObjectAspectRatio;

        renderObject.height = renderObjectAspectRatio > 1
            ? diagonal * this.options.height * renderObjectAspectRatio
            : diagonal * this.options.height;

        if (this.options.randomize) {

            const randomNumber = getRandomNumberBetween(
                (diagonal * 0.05) * -this.options.randomize,
                (diagonal * 0.05) * this.options.randomize);

            renderObject.width += randomNumber;
            renderObject.height += randomNumber;
        }
    }
}